;
;
export function action(type, payload) {
    return {
        type: type,
        payload: payload,
    };
}
export var AsyncResourceState;
(function (AsyncResourceState) {
    AsyncResourceState["Fetching"] = "fetching";
    AsyncResourceState["Success"] = "success";
    AsyncResourceState["Failure"] = "failure";
    AsyncResourceState["Init"] = "init";
})(AsyncResourceState || (AsyncResourceState = {}));
export function getAsyncResourceState(resource) {
    if (resource.fetching) {
        return AsyncResourceState.Fetching;
    }
    if (resource.fetchError) {
        return AsyncResourceState.Failure;
    }
    if (resource.data) {
        return AsyncResourceState.Success;
    }
    return AsyncResourceState.Init;
}
export function actionFetchStart(type) {
    return {
        type: type,
        payload: {
            meta: AsyncResourceState.Fetching,
        }
    };
}
export function actionFetchSuccess(type, payload) {
    return {
        type: type,
        payload: {
            meta: AsyncResourceState.Success,
            data: payload,
        }
    };
}
export function actionFetchFailure(type, error) {
    return {
        type: type,
        payload: {
            meta: AsyncResourceState.Failure,
            data: error,
        }
    };
}
//# sourceMappingURL=Types.js.map